import OnboardingLayout from '@views/Onboarding/OnboardingLayout';
import React, { useEffect, useMemo, useState } from 'react';
import StateBasedFadeTransition from '@components/transitions/StateBasedFadeTransition';
import { previousAuthPlatform } from '@support/jwt';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SignupOverlay } from './Finish';
import Intro from './Intro';
import ProfileForm from './ProfileForm';
import { useAuthContext } from '@hooks/use-auth-context';
import Finish from './Finish';
import { apiRequest } from '@support/api';

type AddBirthdayStep = 'intro' | 'addBirthday' | 'finish' | 'loading';

export interface Requester {
  first_name?: string;
  last_name?: string;
}

export interface Birthday {
  month?: number;
  day?: number;
  year?: number;
}

export interface Profile {
  first_name?: string;
  last_name?: string;
  birthday?: Birthday;
  avatar_url?: string;
  avatar_options?: string[];
}

export default function AddBirthday() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const lastProvider = useMemo(() => previousAuthPlatform(), []);
  const personID = useMemo(() => searchParams.get('id'), []);
  const [step, setStep] = useState<AddBirthdayStep>('loading');
  const { user } = useAuthContext();
  const [personProfile, setPersonProfile] = useState<Profile>({});
  const [requester, setRequester] = useState<Requester>({});

  useEffect(() => {
    const getPersonProfile = async () => {
      try {
        const birthdayRequest = await apiRequest<{ requester: Requester; data: Profile }>(
          'GET',
          `/public-data/${personID}/`,
          undefined,
          { apiVersion: 'v2', noAuthorization: true },
        );
        setPersonProfile(birthdayRequest.data || {});
        setRequester(birthdayRequest.requester || {});
        setStep('intro');
      } catch (_) {
        navigate('/');
      }
    };

    if (personID) {
      getPersonProfile();
    } else {
      navigate('/');
    }
  }, []);

  return (
    <>
      <OnboardingLayout
        includeLogo={!(step === 'finish' && !user)}
        includeFooter={false}
        responsive
      >
        <StateBasedFadeTransition
          state={step}
          elementByStateMap={{
            loading: <div style={{ height: 472, gridRow: 2, gridColumn: 2 }} />,
            intro: <Intro requester={requester} finishStep={() => setStep('addBirthday')} />,
            addBirthday: (
              <ProfileForm
                defaultProfile={personProfile}
                personID={personID}
                finishStep={() => setStep('finish')}
              />
            ),
            finish: <Finish />,
          }}
        />
      </OnboardingLayout>
      {step === 'finish' && <SignupOverlay userHasExistingAccount={!!lastProvider} />}
    </>
  );
}
